__webpack_require__.p = "https://static.age.awaze.com/search-mfe/ec1919f/_next/";